import instanceCommon from "./common"
import { authInterceptor } from "../interceptors"

authInterceptor()

export const instances = { instanceCommon }
